import type { TUserProfileClientInfo_Promo } from '../../../repositories/chats/entities/user_profile/UserProfileClientInfo';
import type { IUserProfilePromo } from '../../../types/userProfile';

export const mapPromo = (promo: TUserProfileClientInfo_Promo | undefined): IUserProfilePromo | null => {
  if (!promo) {
    return null;
  }

  const { title, features, info } = promo;

  return {
    title,
    features,
    info: info || undefined,
  };
};
